// Help's setting in Settings' index (TI's src/chrome/settings/index.ts), so Settings' search and the command bar find it
// from the start: Show tips, in Appearance, where the UI guide puts it.

import { addSettings } from "../chrome/settings";

addSettings([
  {
    id: "show-tips",
    section: "appearance",
    title: "Show tips",
    line: "A few pointers the first time you open each kind of board, and now and then a faster way to do something. Each shows once.",
    words: "tips hints help onboarding pointers tour did you know getting started",
  },
]);
